import axios from 'axios';
import config from '../../../config'; // Asegúrate de que el path sea correcto

const baseUrl = config.baseUrl;
const endpoint = '/api/updateSoportesVisitaTecnica';

// Crear una instancia de Axios con configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Función para subir archivos usando FormData
export const updateSoportesVisitaTecnica = async (formData) => {
  try {
    // Usar la instancia api en lugar de axios.post directamente
    const response = await api.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error al subir archivos:', error.response?.data || error.message);
    throw error;
  }
};
